<template>
  <div class="animated fadeIn mb-3">
    <b-row>
      <b-col>
        <img src="img/brand/logo.png" class="result_detail_logo">
      </b-col>
			<b-col>
				Report #: {{ header.report.number || 'N/A' }}<br>
				Report Date: {{ header.report.report_date || 'N/A' }}<br>
				Received: {{ header.report.received_date || 'N/A' }}<br>
				Completed: {{ header.report.completed_date || 'N/A' }}
        <template v-if="header.report.test_package">
          <br>
          Test Package: {{ header.report.test_package || 'N/A' }}
        </template>
			</b-col>
			<b-col>
				Project: {{ generatePid({'pid': header.report.project}, 'P') || 'N/A' }}<br>
				PO: {{ header.report.po_number || 'N/A' }}
        <template v-if="header.report.grower">
          <br>
          Grower: {{ header.report.grower || 'N/A' }}
        </template>
        <template v-if="header.report.field">
          <br>
          Field: {{ header.report.field || 'N/A' }}
        </template>
        <template v-if="header.report.animal">
          <br>
          Animal: {{ header.report.animal || 'N/A' }}
        </template>
        <template v-if="header.report['H20 Mgmt']">
          <br>
          H20 Mgmt: {{ header.report['H20 Mgmt'] || 'N/A' }}
        </template>
			</b-col>
			<b-col class="text-right">
				Down to Earth Labs<br>
        <template v-for="(str, index) in header.lab.address">
          <span  :key="index">
            {{ str }}<br>
          </span>          
        </template>
        {{ header.lab.phone }}<br>
        {{ header.lab.email }}<br>
        {{ header.lab.website }}
			</b-col>
		</b-row>
  </div>
</template>

<script>
import { generatePid } from '@/shared/utils';

export default {
  name: "SubmissionReportHeader",
  props: {
    header: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    generatePid(entity, prefix) {
      return generatePid({'entity': entity, 'prefix': prefix})
    }
  }
}
</script>
<style>
.result_detail_logo {
	width:100%;
	max-width:230px
}
</style>